<script>
    import ButtonBase from 'common/ButtonBase.svelte';
    import { IDLE } from 'common/callState';
    import { logoutAction } from 'domain/auth/auth.actions';
    import ActiveCall from 'screens/ActiveCall.svelte';
    import IncomingCall from 'screens/IncomingCall.svelte';
    import Modal from 'screens/Modal.svelte';
    import { useFocus, useNavigate } from 'svelte-navigator';
    import Icon from '../../components/Icon.svelte';
    import pubsub from 'sweet-pubsub';
    import { onMount } from 'svelte';

    const navigate = useNavigate();
    const registerFocus = useFocus();

    let settingPopup = false;

    export let input;
    export let sip_connected;
    export let balance_list;

    export let session;
    export let remoteAudio;

    export let call_active;

    export let setNotes;
    export let setCallActive;
    export let take_note;
    export let mobile;
    export let setTakeNote;
    export let incoming_call_active;
    export let answer;
    export let ring;
    export let lines = {}

    const validateInput = (input) => {
        input.value = input.value.replace(/[^0-9]/g, '');
    };

    const hangup = (event) => {
        try {
            session.callSession.terminate();
            setCallActive(false)
        } catch ( e ) {
            console.log(e)
        }
        pubsub.emit('hangup', { mobile: session.peer });
    };

    const mute = () => {
        session.callSession.mute();
        pubsub.emit('mute', { mobile: session.peer });
    };

    const unMute = () => {
        session.callSession.unmute();
        pubsub.emit('unMute', { mobile: session.peer });
    };

    const hold = () => {
        session.callSession.hold();
        pubsub.emit('hold', { mobile: session.peer });
    };

    const unHold = () => {
        session.callSession.unhold();
        pubsub.emit('unHold', { mobile });
    };

    const resetTransfer = (message) => {
        session.isTransfer = false
        session.transferStatus = message || "Transfer completed!"
        setTimeout(() => {
            session.transferStatus = null
        }, 2000)
    }

    const initiateCall = (number, _options) => {
        let options = {
            mediaConstraints: { audio: true, video: false },
            pcConfig: {
                rtcpMuxPolicy: 'negotiate',
                iceServers: [{ urls: ['stun:stun.l.google.com:19302'] }],
            },
            sessionTimersExpires: 1800
        };

        if (_options) {
            options = {
                ...options,
                ..._options
            }
        }

        if (session.state === IDLE || session.isTransfer) {
            const call_session = session.ua.call(number, options);
            setTimeout(() => {
                session.sessions = session.sessions || []
                session.sessions.push(call_session)
            }, 500);
            setCallActive(true);
        }
    };

    const transferCall = e => {
       
        if(!session.duration) {
            session = {
                ...session,
                transferStatus: 'You can only transfer active calls'
            }
            return;
        }
        const { number } = e.detail
        
        session.callSession.hold()

        const eventHandlers = {
            requestSucceeded: function (e) {
                console.log("Transferencia realizada con exito", e);
            },
            requestFailed: function (e) {
                console.log("Transferencia fallo", e);
            },
            trying: function (e) {
                console.log("trying", e);
            },
            progress: function (e) {
                console.log("progress", e);
                // if (e.originator === 'remote')
                e.response.body = null;
            },
            accepted: function (e) {
                console.log("accepted", e, session);
                session.transferStatus = "Call transfered"
                // session.callSession.unHold();
                const sessions = session.sessions || [];
                const firstCallSession = sessions[0];
                const lastCallSession = sessions[sessions.length - 1];
                console.log(firstCallSession, lastCallSession)
                firstCallSession.refer(lastCallSession, {
                    eventHandlers: {
                        accepted: function (e) {
                            session.callSession.unHold();
                        }
                    }
                })
                // session.callSession.terminate();
            },
            failed: function (e) {
                console.log("failed", e);
                resetTransfer(e.message?.reason_phrase || e.cause)
            },
        };

        const options = {
            // mediaConstraints: { audio: true, video: false },
            // pcConfig: {
            //     rtcpMuxPolicy: 'negotiate',
            //     iceServers: [{ urls: ['stun:stun.l.google.com:19302'] }],
            // },
            // sessionTimersExpires: 1800,
            eventHandlers,
            // inviteWithoutSdp: true,
            // rel100: SIP.C.supported.SUPPORTED,
            activeAfterTransfer: false,
            // extraHeaders: [`Contact: <sip:${number}@${lines.host}:${lines.port}>`]
        };
       
        // const uri = new JsSIP.URI('sip', number, lines.host, lines.port)
        // console.log("number to transfer to ======>", number, session.sessions)
        // session.sessions.refer(`sip:48398351676771@fs1.pressone.co`)
        // console.log(JsSIP.C, session.sessions.status)
        // if (session.sessions && session.sessions.status === JsSIP.C.STATUS_CONFIRMED) {
            // Perform the transfer
            // session.sessions.refer('sip:*248398351676771@fs1.pressone.co');
        // } else {
        //     console.error("Cannot perform the transfer. The session is not in a valid state.");
        // }
        // const session2 = session.ua.call(number, options);

        session = {
            ...session,
            isTransfer: true,
            transferStatus: 'Transfering call...'
        }

        // initiateCall(`*2${number}`, options)

        // const uri = new JsSIP.URI('sip', `*2${number}`, lines.host, lines.port)
        const {host, port} = lines;
        const uri = new JsSIP.URI('sip', `${number}`, host, port)
        // console.log(session2.remote_identity.uri)
        // console.log(uri)
        try {
            session.callSession.refer(uri);
        } catch (err) {
            console.dir(err)
        }
    }

    onMount(async () => {
        pubsub.on('initiate_call', (number) => {
            pubsub.emit('dial', number);
            initiateCall(number)
        })
    });

    const logout = () => {
        logoutAction();
        navigate('/login');
    };
</script>

<div id="dialer" class="row content">
    <Modal open={call_active} out_duration={300}>
        <ActiveCall
            on:hangup={hangup}
            on:mute={mute}
            on:unMute={unMute}
            on:hold={hold}
            on:unHold={unHold}
            on:transfer={transferCall}
            bind:session={session}
            state={session.state}
            peer={session.peer}
            {setNotes}
            {setCallActive}
            {take_note}
            {setTakeNote}
        />
    </Modal>
    <Modal open={incoming_call_active} out_duration="200">
        <IncomingCall
            on:hangup={hangup}
            on:answer={answer}
            session={session.callSession}
            peer={session.peer}
           
            {ring}
        />
    </Modal>
    <audio id="remoteAudio" bind:this={remoteAudio} />
    <section class="display-flex marginTop2r">
        <div class="balance-settings">
            <div class="balance">
                <!-- Bal: <span>{balance_list[0]}</span>.<label>{balance_list[1]}</label> -->
            </div>
            <div class="settings">
                <Icon icon="settings" on:click={() => (settingPopup = !settingPopup)} />

                {#if settingPopup}
                    <div class="help-menu">
                        <div class="wrapper">
                            <div class="use-info">
                                <div class="my-number">My number</div>
                                <div class="num">{mobile}</div>
                            </div>

                            <ButtonBase on:click={() => logout()} hasBg={true}>
                                <div class="logout">
                                    Logout <div class="logout-icon">
                                        <Icon icon="logout" />
                                    </div>
                                </div>
                            </ButtonBase>
                        </div>
                    </div>
                {/if}
            </div>
        </div>

        <div class="heading">Dial a number</div>

        <div class="dialer">
            <input
                placeholder="Type number to dial"
                on:input={(e) => validateInput(e.target)}
                bind:value={input}
                use:registerFocus
            />
            <ButtonBase
                on:click={() => initiateCall(input)}
                disabled={!input || !sip_connected}
            >
                <div
                    class="dialer-icon"
                    style:background={sip_connected ? '#dff9e8' : '#f9e8e8'}
                >
                    <Icon icon="dialer" color="#30A059" />
                </div>
            </ButtonBase>
        </div>
    </section>
</div>

<style lang="scss">
   .help-menu {
        position: absolute;
        top: 30px;
        right: 0px;
        width: 180px;
        z-index: 10;
        .wrapper {
            background: white;
            font-size: 1.5em;
            font-weight: 600;
            box-shadow: 0px 2px 12px rgb(21 31 50 / 10%);
            border-radius: 0px 0px 8px 8px;
            .use-info {
                padding: 16px 12px;
                .my-number {
                    font-weight: 400;
                    font-size: 14px;
                    color: #5b6871;
                    margin-bottom: 5px;
                }
                .num {
                    font-weight: 500;
                    font-size: 16px;
                }
            }
            .logout {
                padding: 16px 12px;
                font-weight: 500;
                font-size: 16px;
                border-top: 1px solid #a7b4be;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .logout-icon {
                    margin-left: 8px;
                }
            }
        }
    }

    #dialer {
        display: flex;
        flex-direction: column;
        flex: 1;
        section {
            margin: 0 1.25rem;
            .balance-settings {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                margin-top: 1.5rem;
                margin-bottom: 4.0rem;
                .balance {
                    font-weight: 400;
                    font-size: 16px;
                    padding: 8px 12px;
                    border: 3px solid #cfebf6;
                    border-radius: 40px;
                    span {
                        font-weight: 500;
                    }
                }
                .settings {
                    position: relative;
                }
            }
            .dialer {
                display: grid;
                grid-template-columns: 1fr 48px;
                gap: 12px;
                width: 100%;
                input {
                    padding: 0px 16px;
                    width: 100%;
                    color: #5b6871;
                }
                .dialer-icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 48px;
                    height: 48px;
                    // background: #dff9e8;
                    border-radius: 4px;
                }
            }
        }
    }
</style>
